import { MultiSelectCards } from '../../../components/quiz';
import type { SelectableCardOption } from '../../../types';

interface GoalsStepProps {
  goals: string[];
  onChange: (goals: string[]) => void;
  options: SelectableCardOption[];
  maxSelections?: number;
  otherGoalText?: string;
  onOtherGoalTextChange?: (text: string) => void;
  question?: string;
}

export default function GoalsStep({
  goals,
  onChange,
  options,
  maxSelections = 3,
  otherGoalText = '',
  onOtherGoalTextChange,
  question = "What's your #1 financial goal right now?",
}: GoalsStepProps) {
  const showOtherInput = goals.includes('other');

  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">{question}</h2>
        <p className="quiz-step__helper">The more specific your goals, the more tailored your plan will be</p>
      </div>

      <div className="quiz-step__body">
        <MultiSelectCards
          options={options}
          value={goals}
          onChange={onChange}
          maxSelections={maxSelections}
        />

        {showOtherInput && onOtherGoalTextChange && (
          <div className="goals-other-input">
            <input
              type="text"
              className="goals-other-input__field"
              placeholder="Tell us about your goal..."
              value={otherGoalText}
              onChange={(e) => onOtherGoalTextChange(e.target.value)}
              autoFocus
            />
          </div>
        )}
      </div>
    </div>
  );
}
